<template>
  <div id="app">
    <header-element />
    <router-view/>
    <footer-element />
  </div>
</template>

<script>
import Header from '@/components/header';
import Footer from '@/components/footer';

export default {
  components: {
    'header-element': Header,
    'footer-element': Footer,
  }
}
</script>

<style lang="scss" src="@/styles/style.scss"></style>